import React, { useState, useEffect } from 'react';

const DISMISS_KEY = 'planifpro_install_dismissed';

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null); // évènement beforeinstallprompt (Android/Chrome/desktop)
  const [show, setShow] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Déjà installé ? (mode standalone)
    const standalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    if (standalone) return;
    // Déjà refusé récemment ?
    const dismissedAt = parseInt(localStorage.getItem(DISMISS_KEY) || '0', 10);
    if (dismissedAt && Date.now() - dismissedAt < 1000 * 60 * 60 * 24 * 14) return; // 14 jours

    // iOS Safari : pas de beforeinstallprompt → on affiche des instructions
    const ios = /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
    const isSafari = /^((?!chrome|crios|fxios|android).)*safari/i.test(window.navigator.userAgent);
    if (ios && isSafari) {
      setIsIOS(true);
      const t = setTimeout(() => setShow(true), 3500);
      return () => clearTimeout(t);
    }

    // Android / Chrome / Edge desktop
    let showTimer;
    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferred(e);
      // Délai pour ne pas chevaucher le bandeau cookies au chargement
      showTimer = setTimeout(() => setShow(true), 4000);
    };
    window.addEventListener('beforeinstallprompt', onBeforeInstall);
    // Masquer si l'app vient d'être installée
    const onInstalled = () => { setShow(false); localStorage.setItem(DISMISS_KEY, String(Date.now())); };
    window.addEventListener('appinstalled', onInstalled);
    return () => {
      clearTimeout(showTimer);
      window.removeEventListener('beforeinstallprompt', onBeforeInstall);
      window.removeEventListener('appinstalled', onInstalled);
    };
  }, []);

  const dismiss = () => { setShow(false); localStorage.setItem(DISMISS_KEY, String(Date.now())); };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === 'accepted' || outcome === 'dismissed') {
      setShow(false);
      setDeferred(null);
      if (outcome === 'dismissed') localStorage.setItem(DISMISS_KEY, String(Date.now()));
    }
  };

  if (!show) return null;

  return (
    <div style={{ position: 'fixed', bottom: '16px', left: '50%', transform: 'translateX(-50%)', width: 'calc(100% - 32px)', maxWidth: '440px', background: '#fff', borderRadius: '18px', boxShadow: '0 16px 48px rgba(0,0,0,0.18)', border: '1px solid #e8ecf8', padding: '16px 18px', zIndex: 3000, display: 'flex', alignItems: 'center', gap: '14px', animation: 'pmInstallUp 0.35s cubic-bezier(.4,0,.2,1)' }}>
      <style>{`@keyframes pmInstallUp { from { opacity:0; transform: translate(-50%, 20px); } to { opacity:1; transform: translate(-50%, 0); } }`}</style>

      {/* Icône */}
      <div style={{ width: '46px', height: '46px', borderRadius: '12px', background: 'linear-gradient(135deg,#2563eb,#1e3a8a)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
        <svg width="26" height="26" viewBox="0 0 40 40" fill="none"><path d="M12 20.5L17.5 26L28 14.5" stroke="#fff" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" /></svg>
      </div>

      {/* Texte */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ fontSize: '14px', fontWeight: 700, color: '#111827', margin: '0 0 2px' }}>Installer PlanifPro</p>
        {isIOS ? (
          <p style={{ fontSize: '12px', color: '#6b7280', margin: 0, lineHeight: 1.4 }}>
            Appuie sur <span style={{ fontWeight: 700 }}>Partager</span> <span style={{ fontSize: '13px' }}>􀈂</span> puis <span style={{ fontWeight: 700 }}>« Sur l'écran d'accueil »</span>.
          </p>
        ) : (
          <p style={{ fontSize: '12px', color: '#6b7280', margin: 0, lineHeight: 1.4 }}>Accès direct depuis votre écran d'accueil, en plein écran.</p>
        )}
      </div>

      {/* Actions */}
      {isIOS ? (
        <button onClick={dismiss} style={{ background: '#f3f4f6', border: 'none', borderRadius: '10px', width: '34px', height: '34px', cursor: 'pointer', fontSize: '16px', color: '#6b7280', flexShrink: 0 }}>✕</button>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
          <button onClick={install} style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: '980px', padding: '9px 18px', fontWeight: 700, fontSize: '14px', cursor: 'pointer', whiteSpace: 'nowrap' }}>Installer</button>
          <button onClick={dismiss} style={{ background: '#f3f4f6', border: 'none', borderRadius: '10px', width: '34px', height: '34px', cursor: 'pointer', fontSize: '16px', color: '#6b7280' }}>✕</button>
        </div>
      )}
    </div>
  );
}
